import { motion } from 'framer-motion';

export default function PartnerSection() {
  return (
    <section id="limonta" className="relative py-32 bg-[#1B4D3E] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]" style={{
        backgroundImage: 'repeating-linear-gradient(45deg, #C5A059 0, #C5A059 2px, transparent 2px, transparent 40px)',
      }} />

      <div className="relative max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-3 bg-white/15 px-5 py-2 rounded-full mb-6">
            <span className="font-montserrat text-white text-xs uppercase tracking-wider">Parceiro Oficial</span>
            <img
              src="https://static.readdy.ai/image/f7081275c8c5ad77b7068ab2b9330b46/a2ec951c372cde91e0a8ee7fc137a042.png"
              alt="Italian Flag"
              className="h-[14px] w-auto object-contain"
            />
          </div>

          <div className="mb-8">
            <img
              src="https://static.readdy.ai/image/f7081275c8c5ad77b7068ab2b9330b46/36a7c96754d53c53f5c292a77810677b.webp"
              alt="Limonta Sport"
              className="h-[40px] max-lg:h-[64px] w-auto mx-auto object-contain"
              translate="no"
            />
          </div>

          <h2 className="font-cinzel font-semibold text-white text-[52px] leading-[1.3] mb-4 max-lg:text-[28px] max-lg:text-center max-lg:leading-[1.4]">
            Tecnologia Italiana de Classe Mundial
          </h2>
          <p className="font-montserrat text-white/80 text-lg max-w-[700px] mx-auto">
            Parceria exclusiva com a{' '}<span translate="no" className="notranslate">Limonta Sport</span>, líder global em soluções para gramados esportivos e decorativos
          </p>
        </motion.div>

        <div className="grid grid-cols-3 gap-1 max-w-[1000px] mx-auto max-lg:grid-cols-1 max-lg:gap-[30px] max-lg:max-w-[400px]">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-center py-12 border-r border-[#C5A059]/30 max-lg:border-r-0 max-lg:border-b max-lg:border-[#C5A059]/30 max-lg:py-6"
          >
            <div className="font-montserrat font-bold text-[#C5A059] text-[64px] leading-none mb-3 max-lg:text-[48px]">50+</div>
            <div className="font-montserrat text-white text-base">Anos de Inovação</div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-center py-12 border-r border-[#C5A059]/30 max-lg:border-r-0 max-lg:border-b max-lg:border-[#C5A059]/30 max-lg:py-6"
          >
            <div className="font-montserrat font-bold text-[#C5A059] text-[64px] leading-none mb-3 max-lg:text-[48px]" translate="no">FIFA</div>
            <div className="font-montserrat text-white text-base" translate="no"><span className="notranslate">Certificação de Qualidade</span></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="text-center py-12 max-lg:py-6"
          >
            <div className="font-montserrat font-bold text-[#C5A059] text-[64px] leading-none mb-3 max-lg:text-[48px]">100%</div>
            <div className="font-montserrat text-white text-base">Garantia Técnica</div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.8, duration: 0.6 }}
          className="text-center mt-16"
        >
          <a
            href="https://www.limontasport.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border-2 border-[#C5A059] text-[#C5A059] font-montserrat font-semibold text-sm uppercase tracking-wide px-10 py-4 rounded-full hover:bg-[#C5A059] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            <span translate="no" className="notranslate">Conheça a Limonta</span>
            <i className="ri-external-link-line text-lg"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
